import script from "./ExpandableDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpandableDetails.vue?vue&type=script&setup=true&lang=js"

import "./ExpandableDetails.vue?vue&type=style&index=0&id=9fd451ac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9fd451ac"]])

export default __exports__